export const AUTH_TOKEN_SESSION_KEY = 'A_T';
export const AUTH_TOKEN_HEADER_NAME = 'AuthToken';
export const GLOBAL_RESTOR_HEADER_NAME = 'RestoreClient';
export const TV_MODE_TOKEN = 'TvModeToken';
export const AWS_CDN_FOLDER_PATH = 'brands/images';
